const testimonials = [
  {
    name: "Sarah M.",
    location: "Tampa, FL",
    rating: 5,
    text: "I needed my passport renewed in under a week for a business trip. Fast Passport Center made it completely stress-free. Started online, shipped overnight, and had it back in 4 days. Incredible service.",
    service: "Passport Renewal",
  },
  {
    name: "Mike R.",
    location: "St. Petersburg, FL",
    rating: 5,
    text: "My son's passport expired two weeks before our cruise from Port Tampa Bay. I thought we were going to miss the trip. FPC got us sorted in 5 days flat. Their team was on the phone with me every step of the way.",
    service: "Child Passport",
  },
  {
    name: "Lisa T.",
    location: "Clearwater, FL",
    rating: 5,
    text: "Lost my passport right before an international flight. I was panicking. The team walked me through the DS-64, got my replacement processed, and I had it in hand with a day to spare. Forever grateful.",
    service: "Lost Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TampaTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Tampa Bay Travelers Say About Our Emergency & Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Tampa, St. Petersburg, and Clearwater who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}